// extracted by mini-css-extract-plugin
module.exports = {"textCard":"text-module--text-card--yPN1b"};